import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { FireAssessmentService } from 'src/app/services/fire-assessment.service';
import { ActivatedRoute, Router } from "@angular/router"; // ActivatedRoue is used to get the current associated components information.
import { Location } from '@angular/common';  // Location service is used to go back to previous component
import * as firebase from 'firebase/app';
import { DataSnapshot } from '@angular/fire/database/interfaces';
import { CommonModule } from '@angular/common';
import * as html2pdf from 'html2pdf.js';
import { AuthGuard } from 'src/app/shared/guard/auth.guard';
import { B2Bvalue, B2Cvalue, showQ15to17 } from 'src/app/components/assessment/add-assessment/add-assessment.component';
import { assessmentApiEndpoint } from 'src/app/consts/conts.global';
import { HttpClient } from '@angular/common/http';
import { first } from 'rxjs/operators';


interface ImplementationStatus {
  value: string;
  viewValue: string;
}



@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss'],
})

export class ResourcesComponent implements OnInit {
 

  
  //implement Read More
  isReadMore = true;

  showTxt() {
    this.isReadMore = !this.isReadMore;
  }

  
  constructor(
    public fireAssessment: FireAssessmentService,
    private router: Router,
    private location: Location,
    private actRoute: ActivatedRoute,
    private guard: AuthGuard,
    private http: HttpClient

  ) { }



  //declare form variable here

  data!: any;
  public excellent: string = 'Excellent';
  public good: string = 'Good';
  public average: string = 'Average';
  public belowAverage: string = 'Below Average';
  public poor: string = 'Poor';

  //Demographics

  demographicsNameArray: string[] = [];
  demographicsCheckBoxCount!: number;
  locationCheckBoxCount!: number;
  locationNameArray: string[] = [];
  offerType: string;
  busiName: string;
  busiFirstName: string;
  busiLastName: string;
  busiZipcode: string;
  busiRegType: string;

  //Offer Importance
  offerMarkSize!: number;
  offerIndustryGrowth!: number;
  offerUrgency!: any; //change in html
  offerEssential!: number;
  offerFrequency!: any;
  offerUrgencyRec!: string;
 // offerMandatedRec!: string;
  offerFrequencyRec!: string;
  finalOfferImportanceScore!: string;
  offerImportanceReccommendations!: string;
  offerImportanceMaxPoints: number = 25;

  //Offer Innovation
  offerDifferentiation!: number;
  offerDiffCheckBoxCount!: number;
  offerDifferentiationNameArray: any[] = [];
  differentiatorsScore!: number;
  offerInnovation!: any;
  offerImproveLife!: number; //change in html
  offerImproveLifeCheckBoxCount!: number;
  offerImproveLifeNameArray: string[] = [];
  offerImproveLifeAbility!: number;
  offerDifferentiatorsSelectionRec!: string;
  offerDifferentiatorsRec!: string;
  offerInnovationRec!: string;
  offerImproveLifeRec!: string;
  offerInnovationReccomendations!: string;
  finalOfferInnovationScore!: string;
  offerInnovationMaxPoints: number = 15;

  //Offer Industry
  offerSupplierPower!: number;
  offerSupplierNameArray: string[] = [];
  offerSupplierType!: string;
  offerBuyerPower!: number;
  offerMarkEntry!: number;
  offerMarkEntryNameArray: string[] = [];
  offerIndustry!: string;
  offerMarkEntryCheckBoxCount!: number;//LOOK
  markBarScore!: number;
  industryGrowthScore!: number;
  industryGrowthPerce!: number;
  industryProjection!: number;
  industryGrowthRating!: string;
  offerIndustryGrowthRec!: string;
  pmfOverproductionRec!: string;
  offerBuyerPowerRec!: string;
  offerImproveLifeEssentialityScore: number;
  offerSupplierPowerRec!: string;
  finalOfferIndustryScore!: string;
  offerIndustryReccomendations!: string;
  offerIndustryMaxPoints: number = 25;

  //Offer Final
  finalOfferImportancePercentage!: number;
  finalOfferInnovationPercentage!: number;
  finalOfferIndustryPercentage!: number;
  finalOfferOverallScore!: string;

  //Market

  // B2C
  marketTargetAge!: any;
  marketTargetIndustry!: string;
  marketTargetLocation!: any;
  marketTargetLocationName!: string;
  marketTargetEthnicity!: any;
  marketTargetGender!: any;
  marketTargetOccupation!: any;


  // B2B
  marketTargetB2BIndustry!: string;
 // marketTargetB2BSize!: string;
  marketTargetB2BOccupation!: string;
  marketTargetB2BDecisionMaker!: string;

  //PMF Overproduction
  pmfOverproduction!: any;
  //offerIndustryGrowth using but already declared
  pmfOverproductionMaxPoints: number = 10;
  finalpmfOverproductionScore!: string;

  //PMF Consumer Demand
  pmfCompetitorDemand!: any;
  pmfCompetitorSatisfaction!: any;
  pmfCompetitorDissatisfaction!: any;
  pmfCompetitorDissatisfactionCheckBoxCount!: any;
  pmfCompetitorDissatisfactionNameArray: string[] = [];
   pmfCompetitorDissatisfactionExists: boolean;
   offerDifferentiationExists: boolean;
   //selectedDiff!: any;
  solveNeedRate!: number;
  solveNeedPercentage!: any;
  pmfSolveNeedScore!: number;
  finalpmfConsumerDemandScore!: string;
  pmfConsumerDemandMaxPoints: number = 5;

  //PMF Final
  finalpmfOverproductionPercentage!: number;
  finalpmfConsumerDemandPercentage!: number;
  finalPMFOverallScore!: string;

  // Team Technical
  teamRole!: number;
  teamRoleExists: boolean;
  teamRoleCheckBoxCount!: number;
  teamRoleNameArray: string[] = [];
  //selectedTeamRole : string[]; //LOOK
  teamMembersQuan!: number;
  teamIndustryKnowledge!: number;
  teamTime!: number;
  teamTechnicalReccomendations!: string;
  finalTeamTechnicalScore!: string;
  teamTechnicalMaxPoints: number = 20;
  teamMembers!: number;

  // Team Execution
  teamNetwork!: any;
  teamMentors!: any;
  teamUnadv!: any;
  teamUnadvArrayBranch: any[] = [];
  teamUnadvNameArray: string[] = [];
  teamUnadvCheckBoxCount!: any;
  selectedTeamUnadv!: string[]; //LOOK
  teamOvercomeScore!: number;
  teamTimeManage!: any;
  teamConflict!: any;
  teamAccountability!: any;
  teamUnproductivity!: any;
  teamCTA!: any;
  finalTeamExecutionScore!: string;
  teamExecutionRecomendations!: string;
  teamExecutionMaxPoints: number = 30;

  // Team Personality
  teamTrust!: any;
  teamPassion!: any;
  teamRecognition!: any;
  teamOpenness!: any;
  teamRisk!: any;
  finalTeamPersonalityScore!: string;
  teamPersonalityReccomendations!: string;
  teamPersonalityMaxPoints: number = 25;
  teamPersonalityMaxPointsHidden: number = 10;

  //Final Team
  finalTeamOverallScore!: string;
  finalTeamExecutionPercentage!: number;
  finalTeamPersonalityPercentage!: number;
  finalTeamTechnicalPercentage!: number;

  //Final Overall
  finalOfferOverallAverage!: number;
  finalPMFOverallAverage!: number;
  finalTeamOverallAverage!: number;
  finalOverallAverage!: number;
  finalOverallScore!: string;

  //Chart data
  initCap!: number;
  startingCosts!: number;
  initUsers!: number;
  monthlyUserGrowth!: number;
  monthlyUserLoss!: number;
  revenuePerUser!: number;
  cogs!: number;
  fixedCostPerMonth!: number;

  B2BValueCopy!: number;
  B2CValueCopy!: number;

  assessmentPayload: any;

  ngOnInit(): void {
    this.getAssessmentId();
    this.loadData();
  }

  retrieveRecommandationText(property: string): string {
    const recommendation = this.assessmentPayload?.userAssessmentRecommandations?.find((rec: any) => rec?.hasOwnProperty(property) && rec[property]);
    return (recommendation && recommendation[property]) || '';
  }

  getAssessmentId() {

    const id = this.actRoute.snapshot.paramMap.get('id');
    this.getAssessmentData(id);
  }

  getAssessmentData(id: string) {
    //define all variables of a single assessment
    this.http.get(`${assessmentApiEndpoint}?key=${id}`)
    .pipe(first())
    .subscribe((payload: any) => {
      this.assessmentPayload = payload['value']; console.info(this.assessmentPayload);
      this.fireAssessment.ref = this.fireAssessment.database.ref(`users/${payload?.uid}/${payload?.key}`);
      this.fireAssessment.ref.once("value").then((snapshot) => {
        this.data = snapshot.val();
        this.teamUnadvCheckBoxCount = snapshot.child("teamUnadv/0").numChildren();//fix branch
        this.teamUnadvArrayBranch = snapshot.child("teamUnadv/0").val();
        this.offerMarkEntryCheckBoxCount = snapshot.child("offerMarkEntry").numChildren();
        this.teamRoleCheckBoxCount = snapshot.child("teamRole").numChildren();
        this.offerImproveLifeCheckBoxCount = snapshot.child("offerImproveLife").numChildren();
        this.offerDiffCheckBoxCount = snapshot.child("offerDifferentiation").numChildren();
        this.pmfCompetitorDissatisfactionCheckBoxCount = snapshot.child("pmfCompetitorDissatisfaction").numChildren();
        this.demographicsCheckBoxCount = snapshot.child("busiDemographics").numChildren();
        this.locationCheckBoxCount = snapshot.child("busiLocation").numChildren();
        this.accessAssessmentData();
      });
    });
  }

  declareVariables() {
    //  console.log("this.data.busiFirstName"+this.data.busiFirstName)
    debugger
    this.offerUrgency = this.data.offerUrgency;
    this.offerFrequency = this.data.offerFrequency;
    this.offerType = this.data.offerType;
    this.offerInnovation = this.data.offerInnovation;
    this.pmfOverproduction = this.data.pmfOverproduction;
    this.offerIndustry = this.data.offerIndustry;
    this.offerSupplierPower = this.data.offerSupplierPower;
    this.busiName = this.data.busiName;
    this.busiFirstName = this.data.busiFirstName; 
    this.busiLastName = this.data.busiLastName;
    this.busiZipcode = this.data.busiZipcode;
    this.busiRegType = this.data.busiRegType;
    this.marketTargetLocation = this.data.marketTargetLocation;
    this.offerMarkEntryNameArray = this.data.offerMarkEntryNameArray;
    this.offerBuyerPower = this.data.offerBuyerPower; 
    this.teamIndustryKnowledge = this.data.teamIndustryKnowledge;
    this.teamTime = this.data.teamTime;
    this.teamMembersQuan = this.data.teamMembersQuan;  
    this.teamNetwork = this.data.teamNetwork; 
    this.teamMentors = this.data.teamMentors;
    this.teamTimeManage = this.data.teamTimeManage;
    this.teamAccountability = this.data.teamAccountability;
    this.teamUnproductivity = this.data.teamUnproductivity;
    this.teamPassion = this.data.teamPassion;
    this.teamRisk = this.data.teamRisk;

   if (showQ15to17) {
    this.teamTrust = this.data.teamTrust;
    this.teamRecognition = this.data.teamRecognition; 
    this.teamOpenness = this.data.teamOpenness;
    }

    if (B2Cvalue) {
      this.B2CValueCopy = 1;
      this.B2BValueCopy = 0;
      this.marketTargetAge = this.data.marketTargetAge.name;
      this.marketTargetEthnicity = this.data.marketTargetEthnicity.name;
      this.marketTargetGender = this.data.marketTargetGender.name;
      this.marketTargetOccupation = this.data.marketTargetOccupation.name;
    }

    if (B2Bvalue) {
      this.B2BValueCopy = 1;
      this.B2CValueCopy = 0;
      this.marketTargetB2BIndustry = this.data.marketTargetB2BIndustry.name;
      this.marketTargetB2BOccupation = this.data.marketTargetB2BOccupation.name;
      this.marketTargetB2BDecisionMaker = this.data.marketTargetB2BDecisionMaker.name;
    }

    // chart data
    this.initCap = this.data.initCap;
    this.startingCosts = this.data.startingCosts;
    this.initUsers = this.data.initUsers;
    this.monthlyUserGrowth = this.data.monthlyUserGrowth;
    this.monthlyUserLoss = this.data.monthlyUserLoss;
    this.revenuePerUser = this.data.revenuePerUser;
    this.cogs = this.data.cogs;
    this.fixedCostPerMonth = this.data.fixedCostPerMonth;

  }



  accessAssessmentData() {
    this.declareVariables();

  }

  goBack() {
    this.location.back();
  }

  exportOnClick() {
    const options = {
      filename: 'Sustainible_Recommendations.pdf',
      image: { type: 'jpeg' },
      html2canvas: {},
      jsPDF: { orientation: 'portrait' },
      margin: 12,
      pagebreak: { mode: 'avoid-all' }
    };

    const content: Element = document.getElementById('element-to-export');

    html2pdf()
      .from(content)
      .set(options)
      .save();
  }

  public show: boolean = true;
  public hide: boolean = false;

  toggle() {
    this.show = !this.show;
    this.hide = !this.hide;
  }



   // Business section code
   isEditable: boolean = false;
   text: any = document.getElementById('myText');
   myData: any;
   postData: any = window.localStorage.getItem("save");
   
   // Turns contenteditable to true and hides the edit button after click
   toggleEdit() {
     this.isEditable = true;
   }
 
   // Doesn't save changes reveals edit button again and hides save and cancel buttons
   cancelEdit() {
     this.isEditable = false;
   }
   // Code from https://jsfiddle.net/zrd86n2v/4/
   // These functions are connected to the business section HTML at the end and connected to buttons
 
   // Supposed to load saved text, need to connect to database
   loadData() {
     // if no data
     if (this.postData == null || this.postData == '') {
         this.myData = this.text.innerHTML;
         // store default value
         window.localStorage.setItem("save", this.myData);
         // make it placeholder style
         this.text.classList.remove('changed');
     } else {
         // if there is a value post it
         this.text.innerHTML = this.postData;
         // make dark text
         this.text.classList.add('changed');
     }
   }
 
   // Saves changes and reveals edit button while hiding save and cancel buttons on click
   saveEdit() {
       this.isEditable = false;
       // store the current value
       this.myData = this.text.innerHTML;
       // local store the value
       window.localStorage.setItem("save", this.myData);
       this.text.classList.add('changed');
   }
}
